import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

interface ShareVideoState {
  loading: boolean
  shareUrl: string | null
  videoShare: string | null
  fallbackToShare: boolean
  error: string | null
}

const initialState: ShareVideoState = {
  loading: false,
  shareUrl: null,
  videoShare: null,
  fallbackToShare: false,
  error: null,
}

const shareVideoSlice = createSlice({
  name: 'shareVideo',
  initialState,
  reducers: {
    fetchShareVideo: (state, action: PayloadAction<string>) => {
      state.loading = true
      state.error = null
      state.shareUrl = null
      state.videoShare = null
      state.fallbackToShare = false
    },
    setShareData: (state, action: PayloadAction<{ shareUrl: string; videoShare: string }>) => {
      state.loading = false
      state.shareUrl = action.payload.shareUrl
      state.videoShare = action.payload.videoShare
    },
    fetchShareVideoFailure: (state, action: PayloadAction<string | undefined>) => {
      state.loading = false
      state.error = action.payload ?? null
    },
    setFallbackToShare: (state) => {
      state.loading = false
      state.fallbackToShare = true
    },
    clearShareData: () => initialState,
  },
})

export const shareVideoActions = shareVideoSlice.actions
export const { actions } = shareVideoSlice
export default shareVideoSlice.reducer
